<!-- Anzeige Card -->
@if (news() && !showEditForm) {
    <mat-card role="article">
        <mat-card-header role="heading">
            <mat-card-title>
                <span data-cy="NewsTitel">{{ news()!.freigegeben ? '' : '(geplant) ' }}{{ news()!.betreff }}</span>

                @if (showButtons()) {
                    @if (authService.hasRight('edit-news')) {
                        <button
                            mat-icon-button
                            (click)="editEntry()"
                            matTooltip="Eintrag editieren"
                            data-cy="newsEditBtn">
                            <mat-icon>edit</mat-icon>
                        </button>
                    }
                    @if (authService.hasRight('delete-news')) {
                        <button
                            mat-icon-button
                            (click)="deleteEntry()"
                            matTooltip="Eintrag löschen"
                            data-cy="newsDeleteBtn">
                            <mat-icon>delete</mat-icon>
                        </button>
                    }
                    @if (news() && news()!.bilder && authService.hasRight('delete-news')) {
                        <button
                            mat-icon-button
                            type="button"
                            data-cy="newsAddImage"
                            (click)="showImageUpload = !showImageUpload"
                            matTooltip="Bilder hinzufügen">
                            <mat-icon>add_a_photo</mat-icon>
                        </button>
                    }
                }
            </mat-card-title>
            <mat-card-subtitle>{{ news()!.datum | date }}</mat-card-subtitle>
        </mat-card-header>

        <!-- Bilder mit Text -->
        <mat-card-content data-cy="bilderCard">
            <kkm-image-gallerie [bilder]="news()?.bilder" />
            <p [innerHTML]="news()!.beschreibung | nl2br | linky"></p>
        </mat-card-content>

        <!-- Image Upload -->
        @if (showImageUpload) {
            <mat-card-content data-cy="NewsUploadCard">
                <kkm-image-upload-composition
                    [(dateien)]="news()!.bilder!"
                    [uploadUrl]="'file/uploadFile/news/'+news()!.id"
                    fileAccept="image/*" />
            </mat-card-content>
        }
    </mat-card>
}

<!-- neu und Edit -->
@if (!news() || showEditForm) {
    <mat-card>
        <form [formGroup]="newsForm" (ngSubmit)="speichern()">
            <mat-card-header>
                <mat-card-title>
                    <span>
                        @if (!news()) {
                            Neuer Eintrag
                        } @else {
                            Edit Eintrag
                        }
                    </span>
                    <button
                        mat-icon-button
                        matTooltip="speichern"
                        type="submit"
                        data-cy="newsSpeichernBtn"
                        [disabled]="!newsForm.valid">
                        <mat-icon>save</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        matTooltip="abbrechen"
                        (click)="abbrechen()"
                        data-cy="newsAbbrechenBtn"
                        type="button">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="flex-row flex-wrap gap-10">
                    <mat-form-field class="flex-grow flexbase-100">
                        <mat-label>Betreff</mat-label>
                        <input
                            matInput
                            placeholder="Ex. Betreff"
                            formControlName="betreff"
                            data-cy="NewsBetreffInput" />
                    </mat-form-field>

                    <mat-form-field class="flex-grow flexbase-100">
                        <mat-label>Beschreibung</mat-label>
                        <textarea
                            matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="2"
                            placeholder="Ex. Text mit Inhalt"
                            formControlName="beschreibung"
                            data-cy="NewsBeschreibungInput"
                            name="inhalt"></textarea>
                    </mat-form-field>

                    <mat-checkbox class="flex-grow flexbase-100" formControlName="freigegeben" data-cy="NewsFreigeben">
                        Eintrag direkt freigeben
                    </mat-checkbox>
                </div>

                <kkm-image-gallerie
                    [bilder]="news()?.bilder"
                    [editButtons]="true && authService.hasRight('delete-news')" />
            </mat-card-content>
        </form>
    </mat-card>
}
